
import Logo from "components/Headers/Logo.js"
import Packages from "components/pages/Packages";
// nodejs library that concatenates strings
import classnames from "classnames";
import { Link } from "react-router-dom";
import './Nav.css'  //indexnavbar css
import React, { useState, useEffect } from "react";
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed


// reactstrap components
import {
  Button,
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav
} from "reactstrap";
import LanguageSwitcher from "translation/LanguageSwitcher";


function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("#9D00B6");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);
  const [logoVisible, setLogoVisible] = React.useState(true); // New state variable for logo visibility

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  useEffect(() => {
    // Cleanup
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    document.querySelector('.page-header').style.minHeight = '350px';
  }, []);

  return (
    <div>
      {/* Logo */}
      <div style={{ position: 'relative', zIndex: '1', display: logoVisible ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center', opacity: ' 0.5s ease'}}>
        <Link to="/index">
          <img src={require("assets/img/tradelinelogo.png")} alt="Logo" style={{ width: '300px', height: 'auto' }}/>
        </Link>
      </div>

      <LanguageSwitcher />

      {/* Navbar */}
      <Navbar 
        expand="lg" 
        style={{ 
          backgroundColor: navbarColor === "navbar-transparent" ? "transparent" : "#9D00B6", 
          transition: "background-color 0.5s ease"
        }}
      >
        <div className="navbar-translate">
          <button
            aria-expanded={navbarCollapse}
            className={classnames("navbar-toggler navbar-toggler", {
              toggled: navbarCollapse,
            })}
            onClick={toggleNavbarCollapse}
          >
            <span className="navbar-toggler-bar bar1" />
            <span className="navbar-toggler-bar bar2" />
            <span className="navbar-toggler-bar bar3" />
          </button>
        </div>

        <Collapse
          // className="justify-content-end"
          style={{ justifyContent: 'space-evenly', padding: '15px' }}
          navbar
          isOpen={navbarCollapse}
        >
          <Nav navbar>
            <NavItem>
              <NavLink
                data-placement="bottom"
                href=""
                target="_blank"
              >
                {/* Add any NavLink content if needed */}
              </NavLink>
            </NavItem>

            <NavItem>
              <Link to="/packages" className="nav-link2">
                <TranslateText text="Tradeline Packages" />
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/creditsweeps" className="nav-link2">
                <TranslateText text="Credit Sweeps" />
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/inquiryremoval" className="nav-link2">
                <TranslateText text="Inquiry Removal" />
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/inventory" className="nav-link2">
                <TranslateText text="Tradeline Inventory" />
              </Link>
            </NavItem>
            {/* <NavItem>
              <Link to="/business" className="nav-link2">
                <TranslateText text="Business Credit Building" />
              </Link>
            </NavItem> */}
            <NavItem>
              <Link to="/support" className="nav-link2">
                <TranslateText text="Support Ticket" />
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/FAQ" className="nav-link2">
                <TranslateText text="Tradeline FAQ's" />
              </Link>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  );
}

export default IndexNavbar;










// // // /*!

// // import React, { useState, useEffect } from "react";
// // import { Link } from "react-router-dom";
// // import classnames from "classnames";
// // import {
// //   Button,
// //   Collapse,
// //   NavbarBrand,
// //   Navbar,
// //   NavItem,
// //   NavLink,
// //   Nav,
// //   Container,
// // } from "reactstrap";

// // function IndexNavbar() {
// //   const [navbarColor, setNavbarColor] = useState("navbar-transparent");
// //   const [navbarCollapse, setNavbarCollapse] = useState(false);

// //   const toggleNavbarCollapse = () => {
// //     setNavbarCollapse(!navbarCollapse);
// //     document.documentElement.classList.toggle("nav-open");
// //   };

// //   useEffect(() => {
// //     const updateNavbarColor = () => {
// //       if (
// //         document.documentElement.scrollTop > 299 ||
// //         document.body.scrollTop > 299
// //       ) {
// //         setNavbarColor("");
// //       } else if (
// //         document.documentElement.scrollTop < 350 ||
// //         document.body.scrollTop < 350
// //       ) {
// //         setNavbarColor("navbar-transparent");
// //       }
// //     };

// //     window.addEventListener("scroll", updateNavbarColor);

// //     return () => {
// //       window.removeEventListener("scroll", updateNavbarColor);
// //     };
// //   }, []);

// //   return (
// //     <Navbar className={classnames("fixed-top", navbarColor)} expand="lg">
// //       <Container>
// //         <div className="navbar-translate">
// //           <button
// //             aria-expanded={navbarCollapse}
// //             className={classnames("navbar-toggler navbar-toggler", {
// //               toggled: navbarCollapse,
// //             })}
// //             onClick={toggleNavbarCollapse}
// //           >
// //             <span className="navbar-toggler-bar bar1" />
// //             <span className="navbar-toggler-bar bar2" />
// //             <span className="navbar-toggler-bar bar3" />
// //           </button>
// //         </div>
// //         <Collapse
// //           className="justify-content-end"
// //           navbar
// //           isOpen={navbarCollapse}
// //         >
// //           <Nav navbar>
// //             <NavItem>
// //               <NavLink
// //                 data-placement="bottom"
// //                 href=""
// //                 target="_blank"
// //               />
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/packages" className="nav-link2">
// //                 Tradeline Packages
// //               </Link>
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/creditsweeps" className="nav-link2">
// //                 Credit Sweeps
// //               </Link>
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/inquiryremoval" className="nav-link2">
// //                 Inquiry Removal
// //               </Link>
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/inventory" className="nav-link2">
// //                 what is a credit sweep
// //               </Link>
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/business" className="nav-link2">
// //                 Business Credit Building
// //               </Link>
// //             </NavItem>
// //             <NavItem>
// //               <Link to="/support" className="nav-link2">
// //                 Support Ticket
// //               </Link>
// //             </NavItem>
           
// //             <NavItem>
// //               <Link to="/faq" className="nav-link2">
// //                 Tradeline FAQ's
// //               </Link>
// //             </NavItem>
// //           </Nav>
// //         </Collapse>
// //       </Container>
// //     </Navbar>
// //   );
// // }

// // export default IndexNavbar;



// // =========================================================
// // * Paper Kit React - v1.3.2
// // =========================================================

// // * Product Page: https://www.creative-tim.com/product/paper-kit-react

// // * Copyright 2023 Creative Tim (https://www.creative-tim.com)
// // * Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/main/LICENSE.md)

// // * Coded by Creative Tim

// // =========================================================

// // * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

// // */
// import Logo from "components/Headers/Logo.js"
// import Packages from "components/pages/Packages";
// // nodejs library that concatenates strings
// import classnames from "classnames";
// import { Link } from "react-router-dom";
// import './Nav.css'  //indexnavbar css
// import React, { useState, useEffect } from "react";

// // reactstrap components
// import {
//   Button,
//   Collapse,
//   NavbarBrand,
//   Navbar,
//   NavItem,
//   NavLink,
//   Nav
// } from "reactstrap";
// import LanguageSwitcher from "components/sections/LanguageSwitcher";



// // function IndexNavbar() {
// //   const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
// //   const [navbarCollapse, setNavbarCollapse] = React.useState(false);

// //   const toggleNavbarCollapse = () => {
// //     setNavbarCollapse(!navbarCollapse);
// //     document.documentElement.classList.toggle("nav-open");
// //   };

// //   React.useEffect(() => {
// //     const updateNavbarColor = () => {
// //       if (
// //         document.documentElement.scrollTop > 299 ||
// //         document.body.scrollTop > 299
// //       ) {
// //         setNavbarColor("");
// //       } else if (
// //         document.documentElement.scrollTop < 350 ||
// //         document.body.scrollTop < 350
// //       ) {
// //         setNavbarColor("navbar-transparent");
// //       }
// //     };

// //     window.addEventListener("scroll", updateNavbarColor);

// //     return function cleanup() {
// //       window.removeEventListener("scroll", updateNavbarColor);
// //     };
// //   });
// //   return (

// function IndexNavbar() {
//   const [navbarColor, setNavbarColor] = React.useState("#9D00B6");
//   const [navbarCollapse, setNavbarCollapse] = React.useState(false);
//   const [navbarFixed, setNavbarFixed] = React.useState(false);
//   const [logoVisible, setLogoVisible] = React.useState(true); // New state variable for logo visibility

//   const toggleNavbarCollapse = () => {
//     setNavbarCollapse(!navbarCollapse);
//     document.documentElement.classList.toggle("nav-open");
//   };

//   useEffect(() => {

//     // Cleanup
//     return () => {
//       window.scrollTo(0, 0);
//     };
//   }, []);

//   useEffect(() => {
//     document.querySelector('.page-header').style.minHeight = '350px';
//   }, []);

//   return (
//     <div>
//       {/* Logo */}
      
//       <div style={{ position: 'relative', zIndex: '1', display: logoVisible ? 'flex' : 'none', alignItems: 'center', justifyContent: 'center', opacity: ' 0.5s ease'}}>
//         <Link to="/index">
//         <img src={require("assets/img/tradelinelogo.png")} alt="Logo" style={{ width: '300px', height: 'auto' }}/>
//         </Link>
//       </div>

//       <LanguageSwitcher/>

//       {/* Navbar */}
//       <Navbar 
       
//         expand="lg" 
//         style={{ 
//           backgroundColor: navbarColor === "navbar-transparent" ? "transparent" : "#9D00B6", 
//           transition: "background-color 0.5s ease"
//         }}
//       >
      
//         <div className="navbar-translate">
      
//           <button
//             aria-expanded={navbarCollapse}
//             className={classnames("navbar-toggler navbar-toggler", {
//               toggled: navbarCollapse,
//             })}
//             onClick={toggleNavbarCollapse}
//           >
//             <span className="navbar-toggler-bar bar1" />
//             <span className="navbar-toggler-bar bar2" />
//             <span className="navbar-toggler-bar bar3" />
//           </button>
//         </div>
        
//         <Collapse
//           // className="justify-content-end"
//           style={{ justifyContent: 'space-evenly', 
//             padding: '15px'
//           }}
//           navbar
//           isOpen={navbarCollapse}
//         >
          
          
//           <Nav navbar>
            
//             <NavItem>
//               <NavLink
//                 data-placement="bottom"
//                 href=""
//                 target="_blank"
                
//               >
               
//               </NavLink>
//             </NavItem>

            

//             <NavItem>
//             <Link to="/packages" className="nav-link2">
//               Tradeline Packages
//               </Link>
//               </NavItem>
//               <NavItem>

//             <Link to="/creditsweeps" className="nav-link2">
//               Credit Sweeps
//               </Link>
//               </NavItem>

//           <NavItem>
//             <Link to="/inquiryremoval" className="nav-link2">
//              Inquiry Removal
//               </Link>
//               </NavItem>

//               <NavItem>
//             <Link to="/inventory" className="nav-link2">
//              t sweep
//               </Link>
//               </NavItem>

//               <NavItem>
//             <Link to="/business" className="nav-link2">
//               Business Credit Building
//               </Link>
//               </NavItem>

//               <NavItem>
//             <Link to="/support" className="nav-link2">
//               Support Ticket
//               </Link>
//               </NavItem>
          
//               <NavItem>
//             <Link to="/FAQ" className="nav-link2">
//               Tradeline FAQ's
//               </Link>
//               </NavItem>
         
//           </Nav>
//         </Collapse>
      
//     </Navbar>
    
//   </div>
//   );
// }

// export default IndexNavbar;
